import { render, staticRenderFns } from "./four-zero-four.vue?vue&type=template&id=a88681fa&lang=html&"
import script from "./four-zero-four.vue?vue&type=script&lang=js&"
export * from "./four-zero-four.vue?vue&type=script&lang=js&"
import style0 from "./four-zero-four.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../rubis-bi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports